import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { Company } from 'modules/domain/company/types'
import { endpoints } from 'modules/endpoints'
import { RequestError } from 'modules/errors'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { ASharedModal, SharedModalContent, SharedModalInputs, SharedModalTitle } from 'views/components/SharedModal'
import { AnalyticsPlaces } from '../analyticsPlaces'
import { CommonFields } from '../components/CommonFields'
import { WorldCompanyFields } from './AddWorldCompany'

type Props = {
  refreshCompany: (arg: boolean) => void
  onClose: () => void
  company: Company
}

export const EditWorldCompany: FC<Props> = ({ onClose, refreshCompany, company }) => {
  const { t } = useTranslation('company')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<WorldCompanyFields>({
    initialValues: {
      payment_delay_days: company.payment_delay_days,
      state_reg_number: company.state_reg_number,
      prepayment: company.prepayment,
      name: company.name,
      inn: company.inn,
      commercial: company.commercial,
    },
    onSubmit: formHandler(() => apiClient.put<WorldCompanyFields>(endpoints.company(company.id), formik.values), {
      onSuccess: () => {
        refreshCompany(true)
        onClose()
      },
      onError: (err) => {
        const error = err as RequestError
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return (
    <ASharedModal id={AnalyticsPlaces.DETAILS_MODAL} onClose={onClose}>
      <SharedModalTitle>{t('commonInfo')}</SharedModalTitle>
      <SharedModalContent>
        <SharedModalInputs>
          <CommonFields.NameCompany formik={formik} />
          <CommonFields.PersonalNumber formik={formik} />
          <CommonFields.RegNumber formik={formik} />

          <CommonFields.PrepaymentState formik={formik} />
          <CommonFields.PaymentDelayDays formik={formik} />
        </SharedModalInputs>
      </SharedModalContent>

      <ADefaultModalFooter
        confirmButtonText={t('common:save')}
        onConfirm={formik.handleSubmit}
        progress={formProgress}
        onClose={onClose}
      />
    </ASharedModal>
  )
}
